






































































































































































































































































import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { merge, omit } from 'lodash';

import { ErrorManager } from '@/models/error';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentFilterParams
} from '@/models';

import { createPdf, createFile } from '@/utils/helpers';
import { IInventoryAdvancePaymentFetchActionPayload } from '@/store/inventory-advance-payment';

import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';
import Auth from '@/mixins/auth';

import InventoryAdvancePaymentActivityDialog from '@/components/inventory-advance-payment/InventoryAdvancePaymentActivityDialog.vue';
import InventoryAdvancePaymentDetailFormDialog from '@/components/inventory-advance-payment/InventoryAdvancePaymentDetailFormDialog.vue';
import InventoryAdvancePaymentSearchFilter from '@/components/inventory-advance-payment/InventoryAdvancePaymentSearchFilter.vue';
import ALPage from '@/components/core/Page/ALPage.vue';
import InventoryAdvancePaymentStatusDisplay from '@/components/requisition-common/InventoryAdvancePaymentStatusDisplay.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import InventoryAdvancePaymentBulkUpdateOwnerDialog from '@/components/inventory-advance-payment/InventoryAdvancePaymentBulkUpdateOwnerDialog.vue';
import { DataTableItemProps } from 'vuetify';

export default mixins(Functions, Auth).extend({
  name: 'InventoryAdvancePaymentListPage',

  components: {
    InventoryAdvancePaymentDetailFormDialog,
    InventoryAdvancePaymentActivityDialog,
    InventoryAdvancePaymentSearchFilter,
    ALPage,
    InventoryAdvancePaymentStatusDisplay,
    ErrorAlert,
    InventoryAdvancePaymentBulkUpdateOwnerDialog
  },

  data() {
    return {
      loading: false,
      exportLoading: false,
      formDialog: false,
      deleteDialog: false,
      sortBy: 'id',
      sortDesc: true,

      params: {
        search: this.$route.query.search as string,
        page: Number(this.$route.query.page ?? 1)
      } as IInventoryAdvancePaymentFetchActionPayload,

      errorMessage: '',
      detailErrorMessage: '',

      headers: [
        {
          text: '',
          sortable: false,
          width: '1px',
          class: 'pr-0 mr-n3',
          value: 'data-table-select'
        },
        { text: 'Req #', sortable: false, value: 'id', width: 70 },
        {
          text: 'Requestor',
          sortable: false,
          value: 'owner.fullName',
          width: 200
        },
        { text: 'Supplier', sortable: false, value: 'supplier', width: 300 },

        { text: 'P.O #', sortable: false, value: 'po_number' },

        {
          text: 'Items',
          sortable: false,
          value: 'num_items',
          align: 'start',
          width: 60
        },
        {
          text: 'Currency',
          sortable: false,
          value: 'currency',
          align: 'center',
          width: 60
        },
        {
          text: 'Amount',
          sortable: false,
          value: 'amount',
          align: 'end',
          width: 130
        },
        {
          text: 'Needed By',
          sortable: false,
          value: 'required_date',
          width: 155
        },
        { text: '', sortable: false, value: 'is_urgent', width: 60 },
        {
          text: 'Status',
          sortable: false,
          value: 'status',
          align: 'center',
          width: 200
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
          align: 'center',
          width: 100
        }
      ],

      isSearchFilterActive: false,

      selectedInventoryAdvancePayments: [] as IInventoryAdvancePayment[],
      bulkActionsMenu: false
    };
  },

  mounted() {
    // update `this.params` from the route query object.
    // omitting `search` and `page` as they are already set in the data vue option
    merge(this.params, omit(this.$route.query, ['page', 'search']));

    this.loading = true;
    this.searchInventoryAdvancePayments(this.params);
  },

  computed: {
    ...mapGetters({
      inventoryAdvancePayments:
        'inventoryAdvancePayment/getInventoryAdvancePayments',
      numQuotes: 'inventoryAdvancePayment/getInventoryAdvancePaymentCount'
    }),

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    },

    extraFiltersApplied(): boolean {
      return Object.values(omit(this.$route.query, ['page', 'search'])).some(
        v => !!v
      );
    },

    isInventoryAdvancePaymentSelected(): boolean {
      return this.selectedInventoryAdvancePayments.length != 0;
    },

    listPageHeight(): number {
      return this.isUserInventoryAdvancePaymentAdmin ? 73 : 37;
    }
  },

  watch: {
    'params.search'(search: string) {
      this.debounceFetchInventoryAdvancePayments({
        ...this.params,
        search: search,
        page: 1
      }).then(() => {
        this.params.page = 1;
      });
    }
  },

  methods: {
    moment,

    ...mapActions({
      fetchInventoryAdvancePayments:
        'inventoryAdvancePayment/fetchInventoryAdvancePayments',
      exportInventoryAdvancePaymentPdf:
        'inventoryAdvancePayment/exportInventoryAdvancePaymentPdf',
      exportInventoryAdvancePayments:
        'inventoryAdvancePayment/exportInventoryAdvancePayments'
    }),

    selectInventoryAdvancePayment(
      inventoryAdvancePayment: IInventoryAdvancePayment,
      props: DataTableItemProps
    ) {
      if (this.isInventoryAdvancePaymentSelected) {
        props.select(!props.isSelected);
      } else {
        this.routeToInventoryAdvancePayment(inventoryAdvancePayment);
      }
    },

    routeToInventoryAdvancePayment(
      inventoryAdvancePayment: IInventoryAdvancePayment
    ) {
      this.$router.push({
        name: 'inventory-advance-payment-detail',
        params: {
          id: String(inventoryAdvancePayment.id)
        }
      });
    },

    exportPdf(inventoryAdvancePayment: IInventoryAdvancePayment) {
      this.loading = true;
      this.exportInventoryAdvancePaymentPdf(inventoryAdvancePayment.id)
        .then((data: Blob) => {
          const fileName = `${
            inventoryAdvancePayment.id
          }-inventory-advance-payment-${moment(new Date()).format(
            'YYYY-MM-DD-HH-mm-ss'
          )}`;
          createPdf(data, fileName);
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    createInventoryAdvancePayment() {
      (this as any).$refs.inventoryAdvancePaymentDetailFormDialog.open();
    },

    openActivitiesDialog(inventoryAdvancePayment: IInventoryAdvancePayment) {
      const dialog = this.$refs
        .inventoryAdvancePaymentActivityDialog as InstanceType<
        typeof InventoryAdvancePaymentActivityDialog
      >;
      dialog.open(inventoryAdvancePayment);
    },

    clearAllErrors(): void {
      this.errorMessage = '';
    },

    async debounceFetchInventoryAdvancePayments(
      params: IInventoryAdvancePaymentFetchActionPayload
    ) {
      this.clearAllErrors();
      this.loading = true;

      return await this.debounce(
        this.searchInventoryAdvancePayments,
        200
      )(params);
    },

    /**
     * @param {IInventoryAdvancePaymentFetchActionPayload} params
     */
    searchInventoryAdvancePayments(
      queryParams: IInventoryAdvancePaymentFetchActionPayload
    ) {
      const params = this.cleanFilterParams(queryParams);

      /* this will update the URL query based on param values. */
      this.$router
        .replace({
          name: 'inventory-advance-payment-list',
          query: params as Record<string, any>
        })
        .catch((e: Error) => e); //catch navigation duplication error

      return this.fetchInventoryAdvancePayments(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    refreshSearchFilter(params: InventoryAdvancePaymentFilterParams) {
      this.clearAllErrors();

      this.loading = true;
      this.searchInventoryAdvancePayments({
        // reset page to 1 when updating params
        page: 1,
        search: this.params.search,
        ...params
      }).then(() => {
        // update params object
        this.params.state = params.state;
        this.params.owner = params.owner;
        this.params.po_number = params.po_number;
        this.params.page = 1;
      });
    },

    cleanFilterParams(params: InventoryAdvancePaymentFilterParams) {
      if (!this.isUserInventoryAdvancePaymentAdmin) {
        delete params.owner;
      }
      return params;
    },

    onUpdatePage(newPage: number) {
      if (newPage != this.params.page) {
        this.debounceFetchInventoryAdvancePayments({
          ...this.params,
          page: newPage
        }).then(() => {
          this.params.page = newPage;
        });
      }
    },

    ownerUpdateRefresh() {
      this.selectedInventoryAdvancePayments = [];
      this.searchInventoryAdvancePayments(this.params);
    },

    exportInventoryAdvancePaymentsCSV() {
      this.exportLoading = true;
      this.clearAllErrors();
      this.exportInventoryAdvancePayments(this.params)
        .then((data: Blob) => {
          const fileName = `inventory-advance-payments-${moment(
            new Date()
          ).format('YYYY-MM-DD-HH-mm-ss')}`;
          createFile(data, fileName, 'csv');
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  }
});
